import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const VIEW_PATTERN_REQUEST = 'VIEW_PATTERN_REQUEST';
export const VIEW_PATTERN_SUCCESS = 'VIEW_PATTERN_SUCCESS';
export const VIEW_PATTERN_ERROR = 'VIEW_PATTERN_ERROR';
export const RESET_VIEW_PATTERN = 'RESET_VIEW_PATTERN';


export const viewPattern = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: VIEW_PATTERN_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/pattern/${id}`,
                headers: headers,

            }).then(function (response) {
                dispatch({
                    type: VIEW_PATTERN_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: VIEW_PATTERN_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}

export const resetViewPattern = () => {
    return dispatch => {
        dispatch({
            type: RESET_VIEW_PATTERN
        })
    }
}



